import { inject, Injectable } from '@angular/core';
import { GenericApiService } from '@core/generic-api/data-access';
import { encodeHtml } from '@core/util';
import { map, Observable } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class DocConverterApiService {
  static DOC_CONVERTER_HTML2PDF = 'doc-converter/html2pdf';

  private _apiService = inject(GenericApiService);

  html2pdf({
    html,
    printOptions,
    accessToken,
  }: {
    html: string;
    printOptions?: { headerTemplate?: string; footerTemplate?: string; [k: string]: unknown };
    accessToken?: string;
  }): Observable<Blob> {
    const headers = this._apiService.createHeaders().set('Authorization', `Bearer ${accessToken}`);
    return this._apiService
      .post(
        DocConverterApiService.DOC_CONVERTER_HTML2PDF,
        {
          html: encodeHtml(html),
          printOptions: printOptions && {
            ...printOptions,
            headerTemplate: encodeHtml(printOptions.headerTemplate),
            footerTemplate: encodeHtml(printOptions.footerTemplate),
          },
        },
        {
          requestOptions: { responseType: 'arraybuffer', headers: typeof accessToken === 'string' ? headers : undefined },
          pretreatmentResponse: false,
        },
      )
      .pipe(map(buffer => new Blob([buffer], { type: 'application/pdf' })));
  }
}
